import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Typography, Breadcrumbs, Link } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export function BreadcrumbsNavbar({
    restaurantId,
    restaurantDisplayName,
    dealName,
    title, 
    onBack 
}) {
    const navigate = useNavigate();

    const handleGoBack = () => {
        if (onBack) {
            onBack();
        } else {
            navigate(-1);
        }
    };

    return (
        <Breadcrumbs aria-label='breadcrumb'>
            <Link
                component={RouterLink}
                underline='hover'
                color='inherit'
                onClick={(e) => {
                    if (onBack) e.preventDefault(); 
                    handleGoBack();
                }}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: 'text.secondary',
                    '&:hover': { color: 'primary.main' }
                }}
            >
                <ArrowBackIcon sx={{ mr: 0.5 }} fontSize='inherit' />
                Back
            </Link>
            
            {dealName && (
                <Link
                    component={RouterLink}
                    underline='hover'
                    color='inherit'
                    to={`/restaurant/${restaurantId}`}
                    sx={{
                        color: 'text.secondary',
                        '&:hover': { color: 'primary.main' }
                    }}
                >
                    {restaurantDisplayName}
                </Link>
            )}
            <Typography
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: 500
                }}
                color='text.primary'
            >
                {title || (dealName ? dealName : restaurantDisplayName)}
            </Typography>
        </Breadcrumbs>
    );
}